import {
  GET_AGENDA_LIST_SUCCESS,
  SET_AGENDA_LIST_LOADING,
  GET_AGENDA_DETAILS_SUCCESS,
  SET_AGENDA_DETAILS_LOADING,
  CLEAR_AGENDA_REDUCER,
} from '../constants/ActionTypes';

const INIT_STATE = {
  agendaOfDay: {
    list: null,
    date: null,
  },
  loadingList: false,
  agendaDetails: {
    data: null,
    date: null,
  },
  loadingDetails: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AGENDA_LIST_SUCCESS: {
      return {
        ...state,
        agendaOfDay: {
          list: action.payload.list,
          date: action.payload.date,
        },
      };
    }
    case SET_AGENDA_LIST_LOADING: {
      return {
        ...state,
        loadingList: action.payload.isLoading,
      };
    }
    case GET_AGENDA_DETAILS_SUCCESS: {
      return {
        ...state,
        agendaDetails: {
          data: action.payload.details,
          date: action.payload.date,
        },
      };
    }
    case SET_AGENDA_DETAILS_LOADING: {
      return {
        ...state,
        loadingDetails: action.payload.isLoading,
      };
    }
    case CLEAR_AGENDA_REDUCER:
      return INIT_STATE;
    default: {
      return state;
    }
  }
};
